import React, { useState, useContext } from 'react'
import { BrowserRouter, Link, Route, Routes, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { f, database, storage, auth } from "./config";
import db from "./config";
import { GlobalContext } from "./Globalstate";
import firebase from "firebase";

function Login() {


    const navigate = useNavigate();
    const [loading, setloading] = useState(false)
    const [{ userdetails, loggedin }, dispatch] = useContext(GlobalContext);
    const [email, setemail] = useState("")
    const [password, setpassword] = useState("")

    const handleSubmit = async () => {
        setloading(true);
        if (email != "" && password != "") {
            try {
                let user = await auth.signInWithEmailAndPassword(email, password);
                if (user) {
                    let userid = f.auth().currentUser;
                    let userids = userid.uid;
                    let user1 = await fetchuserdata(userids);
                    let user2 = await setloggedin(true);
                    navigate("/");
                    setloading(false);
                }
                //dispatch user details to globalstate
                //push to dashoard
            } catch (error) {
                setloading(false);
                console.log(error)
                alert(error)
                // seterror(true);
                // seterrormess(error.message);
                // handleClick3();
            }
        } else {
            alert("email or password is empty")
        }
    };


    const login = async () => {

    };

    const fetchuserdata = async (userid) => {
        var docRef = db.collection("users").doc(userid);
        const fetching = await docRef
            .get()
            .then(function (doc) {
                if (doc.exists) {
                    setdetails(doc.data());
                } else {
                    console.log("No such document!");
                }
            })
            .catch(function (error) {
                console.log("Error getting document:", error);
            });
    };

    const setdetails = (data) => {
        dispatch({ type: "setuserdetails", snippet: data });
    };

    const setloggedin = (data) => {
        dispatch({ type: "setloggedin", snippet: data });
    };


    return (
        <div>
            <Helmet>
                <meta charSet="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <meta httpEquiv="X-UA-Compatible" content="ie=edge" />
                <title> Investment Admin | Login</title>
                {/* Favicon icon */}
                <link rel="icon" type="image/png" sizes="16x16" href="https://chainblockinvestment.com/public/images/logos/logo.png" />
                {/* Font Awesome */}
                <link rel="stylesheet" href="https://chainblockinvestment.com/public/plugins/fontawesome-free/css/all.min.css" />
                {/* Custom Stylesheet */}
                <link rel="stylesheet" href="https://chainblockinvestment.com/public/dashboard/includes/vendor/waves/waves.min.css" />
                <link id="current_style" rel="stylesheet" href="https://chainblockinvestment.com/public/dashboard/includes/css/style.css" />
            </Helmet>

            <div>

                {/* <div id="preloader">
                    <div className="sk-three-bounce">
                        <div className="sk-child sk-bounce1" />
                        <div className="sk-child sk-bounce2" />
                        <div className="sk-child sk-bounce3" />
                    </div>
                </div> */}
                <div id="showSwitcher" className="bg-dark" data-mode="dark"><i className="far fa-lightbulb" /></div>
                <div className="authincation authentication" style={{ backgroundImage: 'url(https://chainblockinvestment.com/public/images/auth/auth-bg3.jpg)' }}>
                    <div className="container">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-xl-5 col-md-6">
                                <div className="mini-logo text-center my-5">
                                    <a href="https://chainblockinvestment.com"><img width={60} src="https://chainblockinvestment.com/public/images/logos/logo.png" alt="" /></a>
                                </div>
                                <div className="auth-form card">
                                    <div className="card-header justify-content-center">
                                        <h4 className="card-title">Sign in</h4>
                                    </div>
                                    <div className="card-body">
                                        <form id="login_form">
                                            <fieldset className="form-group">
                                                <label>Email</label>
                                                <input type="email" className="form-control" id="email" name="email" onChange={(e) => { setemail(e.target.value) }} />
                                            </fieldset>
                                            <fieldset className="form-group">
                                                <label>Password</label>
                                                <div className="input-group" id="password_group">
                                                    <input type="password" className="form-control" id="password" name="password" onChange={(e) => { setpassword(e.target.value) }} />
                                                    <div className="input-group-append">
                                                        <button id="passwordSwitcher" type="button" className="input-group-text"><i className="far fa-eye" /></button>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <div className="form-row d-flex justify-content-between mt-4 mb-2">
                                                <div className="form-group mb-0">
                                                    <label className="toggle">
                                                        <input className="toggle-checkbox" type="checkbox" />
                                                        <span className="toggle-switch" />
                                                        <span className="toggle-label">Remember me</span>
                                                    </label>
                                                </div>

                                            </div>
                                            <div className="text-center">
                                                <button type="button" id="login_button" onClick={handleSubmit} className="btn btn-success btn-block">Log In</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </div>
    )
}

export default Login